/**
 * Collection of design tokens for easing curves used in animations. These curves dictate the speed
 * variation of an animation over its duration.
 */ const motionTimings = {
    standard: [
        0.4,
        0.0,
        0.2,
        1
    ],
    accelerate: [
        0.4,
        0.0,
        1,
        1
    ],
    decelerate: [
        0.0,
        0.0,
        0.2,
        1
    ]
};

export { motionTimings };
//# sourceMappingURL=motion-timings.js.map
